import React from 'react'
import { Link } from "react-router-dom";


const DrVahguruSharanBathija = () => {
    return (
        <>
            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2> Dr. Vahguru Sharan Bathija </h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}> MBBS, MD (DVL), Dermatologist and Cosmetologist</li>
                    </ul>
                </div>
            </section>

            <section className="process-one" style={{ marginTop: "-90px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        {/* <marquee width="100%" direction="left" height="" ><br />
                            <b className='' style={{ fontSize: "18px", color: "green" }}>
                                ✅ ब्रेन स्ट्रोक
                                ✅ पोइजनिंग
                                ✅ साँप का काटना
                                ✅ भर्ती की सुविधा
                                ✅ अन्य सभी अपाताकालीन सुविधाएँ उपलब्ध हैं
                            </b>
                        </marquee> */}
                        {/* Process Block */}
                        <div className="process-block col-lg-4 col-md-12 col-sm-12">
                            <div className="process-block_inner">
                                <div className="process-block_image">
                                    <span className="process-block_icon flaticon-medical-history" style={{ color: '#0f903f' }} />
                                    <img src="assets/img/Dr. Wahgurusharan Bhatija.webp" alt />
                                </div>
                            </div>
                        </div>
                        {/* Process Block */}
                        <div className="process-block col-lg-8 col-md-12 col-sm-12">
                            <div className="process-block_inner">
                                <div className="process-block_content">
                                    {/* <div className="process-block_title">
                                                   <span className="process-block_number"> 8 Years experience</span>
                                               </div> */}
                                    <br />
                                    <br />
                                    <br />
                                    <h3 className="process-block_heading">Dr. Vahguru Sharan Bathija </h3>
                                    <p> MBBS, MD (DVL), Dermatologist and Cosmetologist </p>
                                    {/* <h4>About him:</h4> */}
                                    {/* <div className="process-block_text" style={{ marginTop: "0px" }}>
                                                   नमस्कार,
                                                   मेरा नाम डॉ. मुलायम सिंह यादव है और मैं हड़ी एवं जोड़ रोग विशेषज्ञ हूं। मैंने एमबीबीएस एन.एस.सी.बी. मेडिकल कॉलेज, जबलपुर से किया है और पोस्ट ग्रेजुएशन हड्डी एवं जोड़ रोग विशेषज्ञ जी.आर.एम.सी. ग्वालियर से पूर्ण किया है। जिसमें मुझे गोल्ड मेडल प्राप्त हुआ है। वर्तमान में मैं एक अनुभवी ट्रॉमा एवं जॉइंट रिप्लेसमेंट सर्जन हूं। पिछले 8 वर्षों के अनुभव में मैंने देखा है कि जब मरीजों को घुटनों के खराब होने (घुटनों का ऑस्टियोआर्थराइटिस), कंधे के जाम होने या दर्द (फोजन शोल्डर), एड़ी में दर्द (प्लांटर फैसाइटिस) या फिर कोहनी की समस्या होती है, तो कई बार उन्हें सीधे सर्जरी की सलाह दे दी जाती है। लेकिन मैं आपसे यही कहना चाहता हूं कि सर्जरी से पहले एक बार PRP या स्टेम सेल थेरेपी अवश्य आजमाएँ।
                                               </div> */}

                                </div>

                            </div>
                        </div>

                    </div>

                </div>

            </section>

            <div className="sidebar-page-container left-sidebar" style={{ marginTop: "-230px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="content-side col-lg-12 col-md-12 col-sm-12">
                            <div className="department-detail">
                                <div className="inner-box" >
                                    <h3 className='mt-lg-4'>निम्नलिखित समस्या होने पर सम्पर्क करें</h3>
                                    <div className="graph-outer">
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">

                                                    <li> PRP & Chemical Peeling</li>
                                                    <li> सभी प्रकार के चर्म रोग</li>
                                                    <li> स्किन इंफेक्शन एवं STD</li>
                                                    <li> फंगस, दाग, सफेद दाग, धब्बे आदि</li>
                                                    <li> मुंह पर झाई, काले दाग</li>
                                                    <li> सोरियासिस, पेम्फींगस</li>
                                                    <li> एग्जीमा</li>
                                                    <li> खुजली, लाल दाग</li>
                                                </ul>
                                            </div>
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <ul className="list">
                                                     <li> पिम्पल्स, खील</li>
                                                    <li> लेप्रोसी (कुष्ठ रोग)</li>
                                                    <li> रूसी</li>
                                                    <li> चेहरे पर डलनेस</li>
                                                    <li> तिल, मस्से की सर्जरी</li>
                                                    <li>बालों का झड़ना </li>
                                                    <li> गंजापन</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




        </>
    )
}

export default DrVahguruSharanBathija